var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"current-request-top"},[_c('card-header',{attrs:{"title":_vm.title}}),(_vm.topConfig && _vm.topConfig.data)?[_c('auto-scroll-table',_vm._b({staticStyle:{"width":"100%","height":"310px"},attrs:{"config":_vm.topConfig}},'auto-scroll-table',_vm.$attrs,false))]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }